import React, { useEffect, useRef } from "react";
import lottie, { AnimationItem } from "lottie-web";

import { LottieIconNames } from "../../config/types";

import { icons } from "./model/constants";

type LordIconProps = {
  icon: LottieIconNames;
  size?: number;
  loop?: boolean;
  autoPlay?: boolean;
  fullSize?: boolean;
  name?: AnimationItem["name"];
  destroyName?: AnimationItem["name"];
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
};

export const LottieIcon: React.FC<LordIconProps> = (props) => {
  const {
    icon,
    size,
    loop = false,
    autoPlay = false,
    fullSize = false,
    name,
    destroyName,
    className,
    style = {},
    onClick,
  } = props;

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (destroyName) {
      lottie.destroy(destroyName);
    }

    lottie.loadAnimation({
      container: containerRef.current,
      name: name,
      loop: loop,
      autoplay: autoPlay,
      renderer: "canvas",
      animationData: icons[icon],
    });

    return () => {
      lottie.destroy(destroyName);
    };
  }, [autoPlay, loop]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        width: fullSize ? " 100%" : `${size}px`,
        height: `${size}px`,
        ...style,
      }}
      onClick={onClick}
    />
  );
};
